import { gql } from '@apollo/client'

export default {
  workflowActions: () => gql`
    query GetGroupWorkflowActions($groupIdOrArkId: String!) {
      group(groupIdOrArkId: $groupIdOrArkId) {
        currentWorkflowActions {
          name
          status
          parameters {
            name
            value
          }
          properties {
            name
            value
          }
        }
      }
    }
  `,
  recordMetadataReviewStatus: () => gql`
    query ($rmsId: ID!) {
      recordMetadataReviewStatus(rmsId: $rmsId) {
        status
      }
    }
  `,
  updateWorkflowActionStatus: () => gql`
    mutation UpdateWorkflowActionStatus($params: UpdateWorkflowActionStatusInput) {
      updateWorkflowActionStatus(params: $params) {
        code
        success
        newStatus
        message
      }
    }
  `,
}
